import axios from 'axios';
import { API_url } from '../api.setup';
import { enqueueSnackbar } from 'notistack';
import { ServicePartnerGetModel, ServicePartnerModel } from 'src/models/servicePartner/servicePartnersModel';
import { ServiceConfigModel } from 'src/models/servicePartner/serviceConfigModel';

const API_Controller = '/ServicePartners';

export const ServicePartnerDetailsServices = {
  getAllData: async () => {
    try {
      const respons = await axios.get(`${API_url}${API_Controller}/getall`);
      return respons.data as ServicePartnerModel[];
    } catch (error) {
      throw error;
    }
  },

  getServicePartnerData: async (spId) => {
    try {
      const respons = await axios.get(`${API_url}${API_Controller}/get?id=${spId}`);
      return respons.data as ServicePartnerGetModel;
    } catch (error) {
      throw error;
    }
  },

  getServiceConfig: async (spId: number) => {
    try {
      const respons = await axios.get(
        `${API_url}${API_Controller}/GetServicePartnerServicesMapping?servicePartnerID=${spId}`
      );
      return respons.data as ServiceConfigModel[];
    } catch (error) {
      throw error;
    }
  },

  updateServiceConfig: async (spId: number, serviceList: any[]) => {
    try {
      const respons = await axios.post(
        `${API_url}${API_Controller}/AddOrUpdateServicePartnerServices?servicePartnerID=${spId}`,
        serviceList
      );
      return respons.data as ServiceConfigModel[];
    } catch (error) {
      throw error;
    }
  },

  updateData: async (data: ServicePartnerModel) => {
    const remodel = {
      id: data.id,
      businessName: data.businessName,
      ownerFirstandLastName: data.ownerFirstandLastName,
      ownerMobileNumber: data.ownerMobileNumber,
      ownerEmailId: data.ownerEmailId,
      defaultCityID: data.defaultCityID,
      defaultAreaID: data.defaultAreaID,
      serviceTypeId: data.serviceTypeId,
      address: data.address,
      landmark: data.landmark,
      latitude: data.latitude,
      longitude: data.longitude,
      contactPerson: data.contactPerson,
      contactNumber1: data.contactNumber1,
      contactNumber2: data.contactNumber2,
      registrationNumber: data.registrationNumber,
      gstNumber: data.gstNumber,
      isActive: data.isActive,
      referralCode: data.referralCode,
    };
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/update`,
        remodel
      );
      enqueueSnackbar(
        `Service partner ${data.businessName} updated Successfully`,
        {
          variant: 'success'
        }
      );
      return response.data as ServicePartnerModel[];
    } catch (error) {
      throw error;
    }
  },

  deleteServiceConfig: async (spId: number, serviceId: number) => {
    try {
      const respons = await axios.delete(
        `${API_url}${API_Controller}/RemoveServicePartnerService?servicePartnerID=${spId}&servicesId=${serviceId}`
      );
      return respons.data as ServiceConfigModel[];
    } catch (error) {
      throw error;
    }
  },

  addServiceConfigPrices: async (data) => {

    const currentDate = new Date().toISOString();

    const formattedData = {
      servicePartnerId: data.servicePartnerId,
      serviceId: data.serviceId,
      startDate: data.startDate,
      endDate: data.endDate,
      isActive: true,
      listOfPrices: data.prices.map(price => ({
        carCategoryId: price.id,
        amount: Number(price.amount)
      }))
    };

    try {
      const respons = await axios.post(`${API_url}${API_Controller}/AddServicePartnerServicePrices`, formattedData);
      enqueueSnackbar(`Service partner Added Successfully`, {
        variant: 'success'
      });
      return respons.data as ServicePartnerModel;
    } catch (error) {
      enqueueSnackbar(`Service partner failed to add`, {
        variant: 'error'
      });
      throw error;
    }
  },

  updateServiceConfigPrices: async (data) => {
    const reModel = {
      id: data.id,
      servicePartnerId: data.servicePartnerId,
      serviceId: data.serviceId,
      startDate: data.startDate,
      endDate: data.endDate,
      isActive: true,
      amount: data.amount,
      carCategoryId: data.carCategoryId
    };
    try {
      const respons = await axios.put(
        `${API_url}${API_Controller}/UpdateServicePartnerServicePrice`,
        reModel
      );
      enqueueSnackbar(`Service price Edited Successfully`, {
        variant: 'success'
      });
      return respons.data as ServicePartnerModel[];
    } catch (error) {
      throw error;
    }
  },

  addData: async (data) => {
    try {
      const respons = await axios.post(`${API_url}${API_Controller}`, data);
      enqueueSnackbar(`Service partner Added Successfully`, {
        variant: 'success'
      });
      return respons.data as ServicePartnerModel;
    } catch (error) {
      enqueueSnackbar(`Service partner failed to add`, {
        variant: 'error'
      });
      throw error;
    }
  },

  deleteData: async (id) => {
    try {
      const respons = await axios.delete(`${API_url}${API_Controller}/delete?id=${id}`);
      enqueueSnackbar(`Service partner Deleted Successfully`, {
        variant: 'success'
      });
      return respons.data as ServicePartnerModel;
    } catch (error) {
      enqueueSnackbar(`Service partner failed to add`, {
        variant: 'error'
      });
      throw error;
    }
  },

  getAllServicePrices: async () => {
    try {
      const respons = await axios.get(`${API_url}${API_Controller}/getallServicePartnerServicePrices`);
      return respons.data
    } catch (error) {
      throw error;
    }
  },

  getAllServicePartnersByCity: async (cityId) => {
    try {
      const respons = await axios.get(`${API_url}${API_Controller}/getServicePartnersByCity?cityId=${cityId}`);
      return respons.data
    } catch (error) {
      throw error;
    }
  },

  getServiceOrdersOfSP: async (servicePartnerId: number, startDate: string, endDate: string) => {
    try {
      const response = await axios.get(
        `${API_url}/Bookings/getServiceOrdersForServicePartnerByDateRange`,
        {
          params: { servicePartnerId, startDate, endDate }
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getServicePartnerServicePrice: async (servicePartnerId: number, serviceId: number) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/GetServicePartnerServicePrices?servicePartnerId=${servicePartnerId}&serviceId=${serviceId}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get service partner earning by date range
  getServicePartnerEarningByDateRange: async (
    servicePartnerId: number,
    startDate: string,
    endDate: string
  ) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getServicePartnerEarningByDateRange`,
        {
          params: {
            servicePartnerId,
            startDate,
            endDate
          }
        }
      );
      return response.data;
    } catch (error) {
      enqueueSnackbar('Error fetching service partner earnings', {
        variant: 'error'
      });
      throw error;
    }
  },

  // Get service partner settlement balance
  getServicePartnerSettlementBalance: async (
    servicePartnerId: number,
    date: string
  ) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getServicePartnerSettlementBalance`,
        {
          params: {
            servicePartnerId,
            date
          }
        }
      );
      return response.data;
    } catch (error) {
      enqueueSnackbar('Error fetching settlement balance', {
        variant: 'error'
      });
      throw error;
    }
  },

  getServicePartnersByServiceIdAndCityId: async (serviceId: number, cityId: number) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getServicePartnersByServiceIdAndCityId?serviceId=${serviceId}&cityId=${cityId}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

};


